import { render, staticRenderFns } from "./certificateDetail.vue?vue&type=template&id=ce423b18&"
import script from "./certificateDetail.vue?vue&type=script&lang=js&"
export * from "./certificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./certificateDetail.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports